import { useFavoriteAssignmentsQuery } from './graphql';
import { useFavoriteAssignmentsMutations } from '@mp/hooks/mutations';

interface UseFavoriteButtonLogicParams {
  assignmentId: number;
  onlyUnapplied?: boolean;
}

export const useFavoriteButtonLogic = ({
  assignmentId,
  onlyUnapplied,
}: UseFavoriteButtonLogicParams) => {
  const { ids, isFavorited } = useFavoriteAssignmentsQuery({ onlyUnapplied });
  const { markAsFavoriteMutation, unmarkAsFavoriteMutation, isLoading } =
    useFavoriteAssignmentsMutations();

  const isCurrentlyFavorited = isFavorited ? isFavorited(assignmentId) : ids.includes(assignmentId);

  const toggleFavorite = () => {
    if (isCurrentlyFavorited) {
      unmarkAsFavoriteMutation({ assignmentId });
    } else {
      markAsFavoriteMutation({ assignmentId });
    }
  };

  return {
    isFavorited: isCurrentlyFavorited,
    toggleFavorite,
    isLoading,
  };
};
